import { PositionProxy } from '../../proxy/portfolio';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { SessionService } from '../session';

@Injectable()
export class PositionService {
  constructor(
    private proxy: PositionProxy,
    private sessionService: SessionService
  ) {}

  getProgramPositions(programId: number, asOfDate: Date) {
    return this.proxy.getProgramPositions(programId, asOfDate);
  }

  getProgramPositionLastAsOfDate(programId: number) {
    return this.proxy.getProgramPositionLastAsOfDate(programId);
  }

  getProgramPositionAsOfDate(programId: number, asOfDate: Date) {
    return this.proxy.getProgramPositionAsOfDate(programId, asOfDate).pipe(
      map((dateStr) => {
        return new Date(dateStr);
      })
    );
  }

  getProgramPositionTableConfiguration(programId: number) {
    return this.proxy.getProgramPositionTableConfiguration(programId);
  }

  saveProgramPositionOrders(programId: number, columns: any[]) {
    if (this.sessionService.isShadow()) {
      return this.proxy.getShadowUserDefaultObservable();
    }
    return this.proxy.saveProgramPositionOrders(programId, columns);
  }

  saveProgramPositionGroups(programId: number, columns: any[]) {
    if (this.sessionService.isShadow()) {
      return this.proxy.getShadowUserDefaultObservable();
    }
    return this.proxy.saveProgramPositionGroups(programId, columns);
  }

  getReportUserProgramITDEnd(
    programId: number,
    instanceId: number,
    accountId: number
  ) {
    return this.proxy.getReportUserProgramITDEnd(
      programId,
      instanceId,
      accountId
    );
  }
}
